const permissions = {
  //Admins only
  adminOnly: "admin-only",

  canPreviewHealthCareInfo: "can-preview-student-health-care-info",
  canUpdateHealthCareInfo: "can-update-student-health-care-info",

  canPreviewPermissions: "can-preview-permissions",
  canChangePermissionsDescription: "can-change-permissions-description",

  canPreviewRoles: "can-preview-roles",
  canUpdateRoles: "can-update-roles",
  canCreateRoles: "can-create-roles",
  canAttachPermissionsToRoles: "can-attach-permissions-to-roles",

  canCreateBuildings: "can-create-buildings",
  canUpdateBuildings: "can-update-buildings",
  canPreviewBuildings: "can-preview-buildings",
  canDeleteBuildings: "can-delete-buildings",

  canCreateRooms: "can-create-rooms",
  canUpdateRooms: "can-update-rooms",
  canPreviewRooms: "can-preview-rooms",
  canDeleteRooms: "can-delete-rooms",

  canCreateGoogleClassroomCourse: "can-create-google-classroom-course",
  canUpdateGoogleClassroomCourse: "can-update-google-classroom-course",
  canPreviewGoogleClassroomCourses: "can-preview-google-classroom-courses",
  canResetStudentsGooglePasswords: "can-reset-students-google-passwords",

  canManageClinics: "can-manage-clinics",
  canPreviewClinics: "can-preview-clinics",

  canManageHospitalities: "can-manage-hospitalities",
  canPreviewHospitalities: "can-preview-hospitalities",

  canCreateCampaigns: "can-create-campaigns",
  canUpdateCampaigns: "can-update-campaigns",
  canPreviewCampaigns: "can-preview-campaigns",
  canFinishCampaigns: "can-finish-campaigns",
  canPreviewCandidateGoogleUsers: "can-preview-candidate-google-users",
  canManageCandidateGoogleUsers: "can-manage-candidate-google-users",
  canApproveExamResults: "can-approve-exam-results",

  canPreviewCandidacies: "can-preview-candidacies",
  canCreateCandidacy: "can-create-candidacy",
  canMakeCandidacyCorrections: "can-make-candidacy-corrections",
  canUpdateCandidacyReinstatesRight: "can-update-candidacy-reinstates-rights",
  canManageCandidacySpecialities: "can-manage-candidacy-specialities",
  canUpdateCandidacyScoreComponents: "can-update-candidacy-score-components",
  canUpdateCandidacyInstructionLanguages: "can-update-candidacy-instruction-languages",
  canUpdateCandidacyPreferenceAdditionalData: "can-update-candidacy-preference-additional-data",
  canChangeCandidacyPaidEducation: "can-change-candidacy-paid-education",
  canTransferStudentToStateOrder: "can-transfer-student-to-state-order",
  canApproveCandidacies: "can-approve-candidacies",
  canPayTransactions: "can-pay-cash-transactions",
  canRejectCandidacies: "can-reject-candidacies",
  canUnlockCandidacies: "can-unlock-candidacies",
  canUpdateUserInfoCandidacies: "can-update-user-info-candidacies",
  canChangeCandidacyExamSlot: "can-change-candidacy-exam-slot",
  canPreviewCandidateDeclarations: "can-preview-candidate-declarations",
  canChangeCandidacyExamGrade: "can-change-candidacy-exam-grade",
  canTransferCandidacyPayments: "can-transfer-candidacy-payments",
  canAddIntermediariesToCandidacy: "can-add-intermediaries-to-candidacy",
  canAddCandidacyNote: "can-add-candidacy-note",
  canPreviewPreparatoryYearCandidates: "can-preview-preparatory-year-candidates",
  canEnrollPreparatoryYearCandidates: "can-enroll-preparatory-year-candidates",
  canMarkCandidatesForPreparatoryYear: "can-mark-candidates-for-preparatory-year",

  canPreviewPaymentExpectations: "can-preview-payment-expectations",
  canReceivePaymentExpectations: "can-receive-payment-expectations",

  canPreviewDeclarations: "can-preview-declarations",
  canUpdateDeclarations: "can-update-declarations",
  canCreateDeclarations: "can-create-declarations",
  canAddDocumentsDeclarations: "can-add-documents-declarations",

  canPreviewSpecialityGroups: "can-preview-speciality-groups",
  canManageSpecialityGroups: "can-manage-speciality-groups",

  canPreviewSpecialities: "can-preview-specialities",
  canUpdateSpecialities: "can-update-specialities",
  canCreateSpecialities: "can-create-specialities",
  canPreviewSpecialitiesScoreFormulas: "can-preview-specialities-score-formulas",
  canManageSpecialitiesScoreFormulas: "can-manage-specialities-score-formulas",
  canChangeSpecialitiesPriority: "can-change-specialities-priority",

  canPreivewSpecialityStudyWeeks: "can-preivew-speciality-study-weeks",
  canUpdateSpecialityStudyWeeks: "can-update-speciality-study-weeks",

  canPreviewSchoolSubjects: "can-preview-school-subjects",
  canUpdateSchoolSubjects: "can-update-school-subjects",
  canCreateSchoolSubjects: "can-create-school-subjects",
  canAddSchoolSubjectGrades: "can-add-school-subject-grades",

  canPreviewCyclicExams: "can-preview-cyclic-exams",
  canManageCyclicExams: "can-manage-cyclic-exams",

  canPreviewExams: "can-preview-exams",
  canUpdateExams: "can-update-exams",
  canCreateExams: "can-create-exams",
  canPreviewProfessorsSessionExams: "can-preview-professors-session-exams",
  canAddStudentsToSessionExam: "can-add-students-to-session-exam",

  canManageIndividualExams: "can-manage-individual-exams",

  canPreviewSpecificRequirementTypes: "can-preview-specific-requirements",
  canUpdateSpecificRequirementTypes: "can-update-specific-requirements",
  canCreateSpecificRequirementTypes: "can-create-specific-requirements",

  canPreviewDirections: "can-preview-directions",
  canUpdateDirections: "can-update-directions",
  canCreateDirections: "can-create-directions",
  canDeleteDirections: "can-delete-directions",

  canPreviewHealthInsurances: "can-preview-health-insurances",
  canManageHealthInsurances: "can-manage-health-insurances",

  canPreviewProfessionalDirections: "can-preview-professional-directions",
  canUpdateProfessionalDirections: "can-update-professional-directions",
  canCreateProfessionalDirections: "can-create-professional-directions",

  canPreviewAnnualFees: "can-preview-annual-fees",
  canManageAnnualFees: "can-manage-annual-fees",

  canPreviewStructuralUnits: "can-preview-structural-units",
  canUpdateStructuralUnits: "can-update-structural-units",
  canCreateStructuralUnits: "can-create-structural-units",
  canDeleteStructuralUnits: "can-delete-structural-units",

  canPreviewStructuralUnitGroupSpecifications: "can-preview-structural-unit-group-specifications",
  canUpdateStructuralUnitGroupSpecifications: "can-update-structural-unit-group-specifications",

  canPreviewSpecialityGroupSpecifications: "can-preview-speciality-group-specifications",
  canUpdateSpecialityGroupSpecifications: "can-update-speciality-group-specifications",
  canPreviewSpecialityStreamSpecifications: "can-preview-speciality-stream-specifications",
  canUpdateSpecialityStreamSpecifications: "can-update-speciality-stream-specifications",

  canPreviewStudyDepartmentInfo: "can-preview-study-departments-info",
  canUpdateStudyDepartmentInfo: "can-update-study-departments-info",

  canPreviewEmployers: "can-preview-employers",
  canManageEmployers: "can-manage-employers",
  canPreviewJobs: "can-preview-jobs",
  canManageJobs: "can-manage-jobs",
  canPreviewAlumniEvents: "can-preview-alumni-events",
  canManageAlumniEvents: "can-manage-alumni-events",
  canPreviewAlumni: "can-preview-alumni",
  canManageAlumni: "can-manage-alumni",

  canPreviewEmployees: "can-preview-employees",
  canUpdateEmployees: "can-update-employees",
  canCreateEmployees: "can-create-employees",
  canAttachRolesToEmployees: "can-attach-roles-to-employees",
  canAttachPermissionsToEmployees: "can-attach-permissions-to-employees",

  canPreviewEmployeeTitles: "can-preview-employee-titles",
  canUpdateEmployeeTitles: "can-update-employee-titles",
  canCreateEmployeeTitles: "can-create-employee-titles",
  canDeleteEmployeeTitles: "can-delete-employee-titles",

  canPreviewEmployeePositions: "can-preview-employee-positions",
  canUpdateEmployeePositions: "can-update-employee-positions",
  canCreateEmployeePositions: "can-create-employee-positions",
  canDeleteEmployeePositions: "can-delete-employee-positions",

  canPreviewEmployeeTypes: "can-preview-employee-types",
  canUpdateEmployeeTypes: "can-update-employee-types",
  canCreateEmployeeTypes: "can-create-employee-types",

  canPreviewTechnicalEquipment: "can-preview-technical-equipment",
  canUpdateTechnicalEquipment: "can-update-technical-equipment",
  canCreateTechnicalEquipment: "can-create-technical-equipment",

  canPreviewProfessorsClasses: "can-preview-professors-classes",
  canPreviewClassAttendance: "can-preview-class-attendance",
  canUpdateClassAttendance: "can-update-class-attendance",
  canPreviewUsedEquipment: "can-preview-used-equipment",
  canUpdateUsedEquipment: "can-update-used-equipment",
  canUpdateClassProfessor: "can-update-class-professor",

  canPreviewPreferences: "can-preview-preferences",
  canManagePreferences: "can-manage-preferences",
  canCreatePreferences: "can-create-preferences",
  canDeletePreferences: "can-delete-preferences",

  canPreviewBankTransfers: "can-preview-bank-transfers",
  canChangeBankTransferStatus: "can-change-bank-transfer-status",

  canPreviewOnlinePayments: "can-preview-online-payments",
  canPreviewCashPayments: "can-preview-cash-payments",

  canPreviewIbanDetails: "can-preview-iban-details",
  canUpdateIbanDetails: "can-update-iban-details",
  canCreateIbanDetails: "can-create-iban-details",
  canDeleteIbanDetails: "can-delete-iban-details",

  canPreviewEmailGroups: "can-preview-email-groups",
  canManageEmailGroups: "can-manage-email-groups",

  canSeeMenuReports: "can-see-menu-reports",
  canGenerateReports: "can-generate-reports",

  canPreviewIntermediaries: "can-preview-intermediaries",
  canUpdateIntermediaries: "can-update-intermediaries",
  canCreateIntermediaries: "can-create-intermediaries",
  canDeleteIntermediaries: "can-delete-intermediaries",

  canPreviewGradingScales: "can-preview-grading-scales",
  canUpdateGradingScales: "can-update-grading-scales",
  canCreateGradingScales: "can-create-grading-scales",
  canDeleteGradingScales: "can-delete-grading-scales",

  canPreviewUsers: "can-preview-users",
  canUpdateUsers: "can-update-users",
  canResetUsersPasswords: "can-reset-users-passwords",

  canManageStudentPreviousEducation: "can-manage-student-previous-education",
  canPreviewStudentPreviousEducation: "can-preview-student-previous-education",
  canPreviewStudentEducationInfo: "can-preview-student-education-info",
  canChangeStudentEducationStatus: "can-change-student-education-status",
  canUpdateStudentEducationNote: "can-update-student-education-note",
  canUpdatePreparatoryEducation: "can-update-preparatory-education",
  canPreviewPreparatorySchedules: "can-preview-preparatory-schedules",
  canManagePreparatorySchedules: "can-manage-preparatory-schedules",
  canChangePreparatorySchedulesStatus: "can-change-preparatory-schedules-status",
  canPreviewPreparatoryClasses: "can-preview-preparatory-classes",
  canMoveStudentsBetweenStudyGroups: "can-move-students-between-study-groups",
  canPreviewStudentDeclarations: "can-preview-student-declarations",
  canUpdateStudentSportAthleteInfo: "can-update-student-sport-athlete-info",
  canUpdateStudentProfilePicture: "can-update-student-profile-picture",
  canPreviewStudentInfo: "can-preview-student-info",
  canUpdateStudentInfo: "can-update-student-info",
  canPreviewStudentPreferenceAdditionalData: "can-preview-student-preference-additional-data",
  canUpdateStudentPreferenceAdditionalData: "can-update-student-preference-additional-data",

  canPreviewStudentRecords: "can-preview-student-records",
  canUpdateClassGrade: "can-update-class-grade",
  canPreviewMidSemesterGrades: "can-preview-mid-semester-grades",
  canManageMidSemesterGrades: "can-manage-mid-semester-grades",

  canPreviewAttestations: "can-preview-attestations",
  canManageAttestations: "can-manage-attestations",
  canInterruptForMissingAttestations: "can-interrupt-for-missing-attestations",
  canPreviewStudentEducationAttestations: "can-preview-student-education-attestations",
  canManageStudentEducationAttestations: "can-manage-student-education-attestations",

  canPreviewAcademicDecisions: "can-preview-academic-decisions",
  canManageAcademicDecisions: "can-manage-academic-decisions",

  canPreviewDisciplines: "can-preview-disciplines",
  canUpdateDisciplines: "can-update-disciplines",
  canCreateDisciplines: "can-create-disciplines",

  canPreviewDepartments: "can-preview-departments",
  canUpdateDepartments: "can-update-departments",
  canCreateDepartments: "can-create-departments",

  canPreviewCampaignRankings: "can-preview-campaign-rankings",
  canManageCampaignRankings: "can-manage-campaign-rankings",
  canAddCandidateCampaignRankingAdditionalCapacity: "can-add-candidate-campaign-ranking-additional-capacity",

  canCreateCurriculums: "can-create-curriculums",
  canUpdateCurriculums: "can-update-curriculums",
  canPreviewCurriculums: "can-preview-curriculums",
  canManageStudentsIndividualCurriculums: "can-manage-students-individual-curriculums",
  canPreviewGroupBlacklistCountriesInfo: "can-preview-group-blacklist-countries-info",
  canUpdateGroupBlacklistCountriesInfo: "can-update-group-blacklist-countries-info",

  canPreviewCurriculumModules: "can-preview-curriculum-modules",
  canManageCurriculumModules: "can-manage-curriculum-modules",
  canManageCurriculumDisciplinePrices: "can-manage-curriculum-discipline-prices",

  canPreviewCurriculumSelectionCampaigns: "can-preview-curriculum-selection-campaigns",
  canManageCurriculumSelectionCampaigns: "can-manage-curriculum-selection-campaigns",

  // ElectiveCoursesMF
  canPreviewElectiveCourses: "can-preview-elective-courses",
  canManageElectiveCourses: "can-manage-elective-courses",

  canPreviewSettlements: "can-preview-settlements",
  canSyncSettlements: "can-sync-settlements",

  canRequestScheduleProfessorSubstitute: "can-request-schedule-professor-substitute",

  canManageCyclicSchedules: "can-manage-cyclic-schedules",
  canUpdateCyclicSchedulesProfessors: "can-update-cyclic-schedules-professors",
  canChangeCyclicSchedulesStatus: "can-change-cyclic-schedules-status",
  canPreviewCyclicSchedules: "can-preview-cyclic-schedules",

  canPreviewWeeklySchedule: "can-preview-weekly-schedules",
  canUpdateWeeklyScheduleStatus: "can-change-weekly-schedules-status",
  canCreateWeeklySchedule: "can-create-weekly-schedules",
  canUpdateEverythingInWeeklySchedules: "can-update-everything-in-weekly-schedules",
  canUpdateWeeklySchedulesRoom: "can-update-weekly-schedules-room",
  canUpdateWeeklyScheduleProfessors: "can-update-weekly-schedules-professors",
  canRescheduleWeeklySchedules: "can-reschedule-weekly-schedules",
  canPreviewProfessorSchedule: "can-preview-professor-schedules",
  canSeeAllProfessorsSchedule: "can-see-all-professors-schedules",
  canSeeClassroomsScheduleTab: "can-see-classrooms-schedule-tab",
  canSeeProfessorsScheduleTab: "can-see-professors-schedule-tab",
  canSeeStudentScheduleTab: "can-see-students-schedule-tab",
  canSeeStudyGroupScheduleTab: "can-see-study-group-schedule-tab",

  canPreviewCountries: "can-preview-countries",
  canSyncCountries: "can-sync-countries",

  canPreviewDistricts: "can-preview-districts",
  canSyncDistricts: "can-sync-districts",

  canPreviewMunicipalities: "can-preview-municipalities",
  canSyncMunicipalities: "can-sync-municipalities",
  canEnrollCandidates: "can-enroll-candidates",

  canCreatePractices: "can-create-practices",
  canUpdatePractices: "can-update-practices",
  canPreviewPractices: "can-preview-practices",

  canCreateInternships: "can-create-internships",
  canUpdateInternships: "can-update-internships",
  canPreviewInternships: "can-preview-internships",
  canManageInternshipSchedulesStudentsAssignments: "can-manage-internship-schedules-students-assignments",
  canCreateSingleStateExam: "can-create-single-state-exam",
  canCreateGroupStateExams: "can-create-group-state-exams",

  canCreateStateExams: "can-create-state-exams",
  canUpdateStateExams: "can-update-state-exams",
  canPreviewStateExams: "can-preview-state-exams",
  canManageStateExamCommission: "can-manage-state-exam-commission",
  canManageStateExamStudyGroups: "can-manage-state-exam-study-groups",
  canManageStateExamSlot: "can-manage-state-exam-slot",
  canPreviewStateExamResults: "can-preview-state-exam-results",
  canManageStateExamResults: "can-manage-state-exam-results",

  canPreviewAcademicYears: "can-preview-academic-years",
  canUpdateAcademicYears: "can-update-academic-years",
  canCreateAcademicYears: "can-create-academic-years",

  canPreviewAcademicSessions: "can-preview-academic-sessions",
  canUpdateAcademicSessions: "can-update-academic-sessions",
  canCreateAcademicSessions: "can-create-academic-sessions",
  canFinalizeAcademicSessions: "can-finalize-academic-sessions",

  canPreviewSessionExams: "can-preview-session-exams",
  canCreateSessionExams: "can-create-session-exams",
  canUpdateSessionExamProfessors: "can-update-session-exam-professors",
  canPreviewSessionExamStudents: "can-preview-session-exam-students",
  canUpdateSessionExamGrades: "can-update-session-exam-grades",

  canPreviewSentEmailsHistory: "can-preview-sent-emails-history",
  canResendEmails: "can-resend-emails",

  canPreviewPreparatoryCourses: "can-preview-preparatory-courses",
  canCreatePreparatoryCourses: "can-create-preparatory-courses",
  canUpdatePreparatoryCourses: "can-update-preparatory-courses",

  canPreviewAcademicRequests: "can-preview-academic-requests",
  canChangeAcademicRequestStatus: "can-change-academic-request-status",
  canGenerateAcademicRequestDocuments: "can-generate-academic-request-documents",
  canPreviewAcademicRequestDataIssues: "can-preview-academic-request-data-issues",
  canMarkYoungChildrenMothers: "can-mark-young-children-mothers",

  canApproveStaffRequest: "can-approve-staff-requests",
  canRejectStaffRequest: "can-reject-staff-requests",
  canPreviewStaffRequests: "can-preview-staff-requests",
  canSeeOthersStaffRequests: "can-see-others-staff-requests",

  canMarkStudentDormitoryUsage: "can-mark-student-dormitory-usage",

  canPreviewAcademicYearHolidays: "can-preview-academic-year-holidays",
  canUpdateAcademicYearHolidays: "can-update-academic-year-holidays",

  canPreviewUnassignedStudyGroupStudents: "can-preview-unassigned-study-group-students",
  canNotifyDepartmentsForWeeklyScheduleCreation: "can-notify-departments-for-weekly-schedule-creation",

  canUpdateSessionExamSlots: "can-update-session-exam-slots",
  canUpdateSessionExamStudyGroups: "can-update-session-exam-study-groups",
  canUpdateSessionExamIntention: "can-update-session-exam-intention",

  canPreviewTreeStructure: "can-preview-tree-structure",
  canChangeTreeStructure: "can-change-tree-structure",

  canPreviewCamps: "can-preview-camps",
  canUpdateCamps: "can-update-camps",
  canCreateCamps: "can-create-camps",

  canPreviewCurriculumDisciplineTopics: "can-preview-curriculum-disciplines-topics",
  canManageCurriculumDisciplinesTopics: "can-manage-curriculum-disciplines-topics",

  // Students
  canPreviewStudentPersonalDocuments: "can-preview-student-personal-documents",
  canManageStudentPrersonalDocuments: "can-manage-student-personal-documents",
  canPreviewStudentsForeignLanguages: "can-preview-students-foreign-languages",
  canManageStudentsForeignLanguages: "can-manage-students-foreign-languages",
  canPreviewStudentsSportActivities: "can-preview-students-sport-activities",
  canManageStudentsSportActivities: "can-manage-students-sport-activities",
  canTransferStudentEducationFaculty: "can-transfer-student-education-faculty",
  canTransferStudentEducationCurriculum: "can-transfer-student-education-curriculum",
  canManageStudentsAllDisciplinesGrades: "can-manage-students-all-disciplines-grades",

  // Foreign Languages
  canPreviewActivitiesForeignLanguages: "can-preview-activities-foreign-languages",
  canManageActivitiesForeignLanguages: "can-manage-activities-foreign-languages",
  canPreviewForeignLanguagesCapacities: "can-preview-activities-foreign-languages-capacities",
  canManageForeignLanguagesCapacities: "can-manage-activities-foreign-languages-capacities",
  canManageForeignLanguagesEntryTests: "can-manage-activities-foreign-languages-entry-tests",
  canCreateForeignLanguages: "can-create-foreign-languages",
  canUpdateForeignLanguages: "can-update-foreign-languages",
  canPreviewForeignLanguages: "can-preview-foreign-languages",

  canPreviewUserDebtHistory: "can-preview-user-debt-history",
  canPreviewDebts: "can-preview-debts",
  canAddDebtPayment: "can-add-debt-payment",
  canPreviewDeposits: "can-preview-deposits",
  canPreviewStudentSemesterFees: "can-preview-student-semester-fees",

  // Sports
  canPrevieSports: "can-preview-sports",
  canManageSports: "can-manage-sports",

  // Activities
  canPreviewForeignLanguageActivities: "can-preview-foreign-language-activities",
  canManageForeignLanguageActivities: "can-manage-foreign-language-activities",
  canPreviewSportActivities: "can-preview-sport-activities",
  canManageSportActivities: "can-manage-sport-activities",

  // Scholarships
  canPreviewScholarshiBudgets: "can-preview-scholarship-budgets",
  canCreateScholarshiBudgets: "can-create-scholarship-budgets",
  canUpdateScholarshipBudgets: "can-update-scholarship-budgets",
  canPreviewScholarshipCampaigns: "can-preview-scholarship-campaigns",
  canCreateScholarshipCampaigns: "can-create-scholarship-campaigns",
  canUpdateScholarshipCampaigns: "can-update-scholarship-campaigns",
  canPreviewScholarshipApplications: "can-preview-scholarship-applications",
  canApproveScholarshipApplications: "can-approve-scholarship-applications",
  canApprovePendingScholarshipApplications: "can-approve-pending-scholarship-applications",
  canApprovePendingAccountingScholarshipApplications: "can-approve-pending-accounting-scholarship-applications",
  canReturnScholarshipApplicationsForCorrection: "can-return-scholarship-applications-for-correction",

  canCreateScholarshipBlacklistStudents: "can-create-scholarship-blacklist-students",
  canUpdateScholarshipsAmount: "can-update-scholarships-amount",
  canPreviewApprovedScholarshipApplicationsBudget: "can-preview-approved-scholarship-applications-budget",
  canFinalizeScholarshipCampaigns: "can-finalize-scholarship-campaigns",
  canUpdateApprovedScholarshipApplicationsStatus: "can-update-approved-scholarship-applications-status",

  //MakeUps
  canPreviewMakeUps: "can-preview-make-ups",
  canManageMakeUps: "can-manage-make-ups",

  //Internships
  canPreviewInternshipSessions: "can-preview-internship-sessions",
  canManageInternshipSessions: "can-manage-internship-sessions",
  canPreviewInternshipPlans: "can-preview-internship-plans",
  canManageInternshipPlans: "can-manage-internship-plans",
  canPreviewInternshipSchedules: "can-preview-internship-schedules",
  canManageInternshipSchedules: "can-manage-internship-schedules",

  canPreviewInternshipStudents: "can-preview-internship-students",

  canManageInternshipStudentsDisciplineRequirements: "can-manage-internship-students-discipline-requirements",
  canStartInternshipForStudents: "can-start-internship-for-students",
  canPreviewInternshipStudentsStatusHistory: "can-preview-internship-students-status-history",
  canPreviewInternshipStudentsDisciplineRequirementHistory:
    "can-preview-internship-students-discipline-requirement-history",
  canManageMonthlyInternshipStart: "can-manage-monthly-internship-start",
  canPreviewMonthlyInternshipAttestations: "can-preview-monthly-internship-attestations",
  canManageMonthlyInternshipAttestations: "can-manage-monthly-internship-attestations",
  canPreviewInternshipStudentsDisciplineRequirements: "can-preview-internship-students-discipline-requirements",

  //Leaves
  canPreviewLeaveRequests: "can-preview-leave-requests",
  canPreviewNodeLeaveRequests: "can-preview-node-leave-requests",
  canManageNodeLeaveDocuments: "can-manage-node-leave-documents",
  canCreateLeaveRequests: "can-create-leave-requests",
  canUpdateLeaveRequests: "can-update-leave-requests",
  canRequestLeavesForAllEmployees: "can-request-leaves-for-all-employees",
  canRequestBusinessTripsForAllEmployees: "can-request-business-trips-for-all-employees",

  //Wards
  canManageWards: "can-manage-wards",
  canPreviewWards: "can-preview-wards",

  // TrainingBases
  canManageTrainingBases: "can-manage-training-bases",
  canPreviewTrainingBases: "can-preview-training-bases",
  canCloneTrainingBases: "can-clone-training-bases",

  canPreviewStudentsTrainingBases: "can-preview-students-training-bases",
  canManageStudentsTrainingBases: "can-manage-students-training-bases",

  // ThesisDefense
  canPreviewThesisDefenseRequests: "can-preview-thesis-defense-requests",
  canManageThesisDefenseRequests: "can-manage-thesis-defense-requests",
  canManageThesisDefenseDate: "can-manage-thesis-defense-date",

  //Erasmus
  canPreviewErasmusRegularStudents: "can-preview-erasmus-regular-students",
  canManageErasmusRegularStudents: "can-manage-erasmus-regular-students",
  canPreviewErasmusInternshipStudents: "can-preview-erasmus-internship-students",
  canManageErasmusInternshipStudents: "can-manage-erasmus-internship-students",
  canManageErasmusCampaigns: "can-manage-erasmus-campaigns",
  canPreviewErasmusCampaigns: "can-preview-erasmus-campaigns",
  canManageOutgoingStudentsCoordinator: "can-manage-outgoing-students-coordinator",
  canManageOutgoingStudentsDean: "can-manage-outgoing-students-dean",
  canManageOutgoingStudentsRector: "can-manage-outgoing-students-rector",
  canManageIncomingInternshipStudentsCoordinator: "can-manage-incoming-internship-students-coordinator",
  canManageIncomingInternshipStudentsHeadOfDepartment: "can-manage-incoming-internship-students-head-of-department",
  canManageIncomingInternshipStudentsSupervisor: "can-manage-incoming-internship-students-supervisor",
  canManageExternalUniversities: "can-manage-universities",
  canPreviewExternalUniversities: "can-preview-universities",
  canPreviewErasmusIncomingTeachers: "can-preview-erasmus-incoming-employees",
  canManageErasmusIncomingTeachers: "can-manage-erasmus-incoming-employees",
  canPreviewErasmusOutgoingTeachers: "can-preview-erasmus-outgoing-employees",
  canManageErasmusOutgoingTeachers: "can-manage-erasmus-outgoing-employees",
  canPreviewErasmusCoordinators: "can-preview-erasmus-coordinators",
  canManageErasmusCoordinators: "can-manage-erasmus-coordinators",

  // Specializations
  canPreviewSpecializations: "can-preview-specializations",
  canManageSpecializations: "can-manage-specializations",
  canPreviewSpecializationFees: "can-preview-specialization-fees",
  canManageSpecializationFees: "can-manage-specialization-fees",

  // Advanced Specializations
  canPreviewAdvancedSpecializations: "can-preview-advanced-specializations",
  canCreateAdvancedSpecializations: "can-create-advanced-specializations",
  canUpdateAdvancedSpecializationsInfo: "can-update-advanced-specializations-info",
  canUpdateAdvancedSpecializationsFees: "can-update-advanced-specializations-fees",
  canUpdateAdvancedSpecializationsProfessors: "can-update-advanced-specializations-professors",
  canManageAdvancedSpecializationsExaminationHeads: "can-manage-advanced-specializations-examination-heads",

  // Advanced SpecializationSpecialist
  canPreviewAdvancedSpecializationSpecialists: "can-preview-advanced-specialization-specialists",
  canManageAdvancedSpecializationSpecialists: "can-manage-advanced-specialization-specialists",

  // Healthcare Courses
  canPreviewHealthcareCourses: "can-preview-healthcare-courses",
  canManageHealthcareCourses: "can-manage-healthcare-courses",
  canPreviewHealthcareCourseDailyPrices: "can-preview-healthcare-course-daily-prices",
  canManageHealthcareCourseDailyPrices: "can-manage-healthcare-course-daily-prices",
  canPreviewHealthcareCourseFeeDistributions: "can-preview-healthcare-course-fee-distributions",
  canManageHealthcareCourseFeeDistributions: "can-manage-healthcare-course-fee-distributions",

  // Specialists' Campaigns
  canPreviewSpecialistCampaigns: "can-preview-specialists-campaigns",
  canManageSpecialistCampaigns: "can-manage-specialists-campaigns",
  canPreviewSpecialistsCampaignExamResults: "can-preview-specialists-campaign-exam-results",
  canManageSpecialistCampaignsExamResults: "can-manage-specialists-campaign-exam-results",

  // Specialists' Campaigns Applications
  canPreviewSpecialistCampaignsApplications: "can-preview-specialists-campaign-applications",
  canManageSpecialistCampaignsApplications: "can-manage-specialists-campaign-applications",
  canChangeSpecialistsCampaignApplicationsStatuses: "can-change-specialists-campaign-applications-statuses",
  canManageSpecialistCampaignApplicationsGrade: "can-manage-specialists-campaign-applications-grade",
  canReturnSpecialistsCampaignApplicationsForCorrection: "can-return-specialists-campaign-applications-for-correction",

  // Healthcare Campaigns
  canPreviewHealthcareCampaigns: "can-preview-healthcare-campaigns",
  canManageHealthcareCampaigns: "can-manage-healthcare-campaigns",

  canPreviewHealthcareCampaignApplications: "can-preview-healthcare-campaign-applications",
  canChangeHealthcareCampaignApplicationsStatuses: "can-change-healthcare-campaign-applications-statuses",
  canManageHealthcareCampaignApplications: "can-manage-healthcare-campaign-applications",

  // Specialists' Postgraduate Courses
  canPreviewSpecialistPostgraduateCourses: "can-preview-postgraduate-courses",
  canManageSpecialistPostgraduateCourses: "can-manage-postgraduate-courses",

  // Specialists' Postgraduate Courses Finalization
  canManageSpecialistPostgraduateCoursesFinalization: "can-finalize-postgraduate-courses-years",

  // Exam Committees
  canPreviewSpecialistsExamCommittees: "can-preview-specialists-exam-committees",
  canCreateSpecialistsExamCommittees: "can-create-specialists-exam-committees",
  canUpdateSpecialistsExamCommitteesInfo: "can-update-specialists-exam-committees-info",
  canUpdateSpecialistsExamCommitteesStatus: "can-update-specialists-exam-committees-status",
  canManageSpecialistsExamCommitteesContact: "can-manage-specialists-exam-committees-contact",
  canManageSpecialistsExamCommitteesMembers: "can-manage-specialists-exam-committees-members",

  // Specializations Curricula
  canPreviewSpecializationsCurricula: "can-preview-specializations-curricula",
  canManageSpecializationsCurricula: "can-manage-specializations-curricula",
  canManageSpecializationsCurriculaItemsPrerequisites: "can-manage-specializations-curricula-items-prerequisites",

  // Specialists
  canPreviewSpecialists: "can-preview-specialists",
  canEnrollSpecialists: "can-enroll-specialists",
  canManageSpecialistsSupervisor: "can-manage-specialists-supervisor",

  canPreviewSpecialistsTrainingBuildings: "can-preview-specialists-training-buildings",
  canManageSpecialistsTrainingBuildings: "can-manage-specialists-training-buildings",

  canManageSpecialistsCurriculumItemCompletions: "can-manage-specialists-curriculum-item-completions",
  canPreviewSpecialistsCurriculumItems: "can-preview-specialists-curriculum-items",
  canManageSpecialistsCurriculumItemEstimations: "can-manage-specialists-curriculum-item-estimations",
  canMakeSpecialistsEligibleForGraduation: "can-make-specialists-eligible-for-graduation",
  canMakeSpecialistsGraduating: "can-make-specialists-graduating",

  // Doctoral
  canPreviewDoctoralDisciplines: "can-preview-doctoral-disciplines",
  canCreateDoctoralDisciplines: "can-create-doctoral-disciplines",
  canUpdateDoctoralDisciplines: "can-update-doctoral-disciplines",
  canPreviewHigherEducationFields: "can-preview-higher-education-fields",
  canCreateHigherEducationFields: "can-create-higher-education-fields",
  canUpdateHigherEducationFields: "can-update-higher-education-fields",
  canPreviewDoctoralPrograms: "can-preview-doctoral-programs",
  canCreateDoctoralPrograms: "can-create-doctoral-programs",
  canUpdateDoctoralPrograms: "can-update-doctoral-programs",
  canPreviewDoctoralSeats: "can-preview-doctoral-seats",
  canCreateDoctoralSeats: "can-create-doctoral-seats",
  canUpdateDoctoralSeats: "can-update-doctoral-seats",
  canApproveDoctoralSeatsByFc: "can-approve-doctoral-seats-by-fc",
  canApproveDoctoralSeatsByAc: "can-approve-doctoral-seats-by-ac",
  canApproveDoctoralSeatsByMon: "can-approve-doctoral-seats-by-mon",
  canPreviewDoctoralCampaigns: "can-preview-doctoral-campaigns",
  canCreateDoctoralCampaigns: "can-create-doctoral-campaigns",
  canUpdateDoctoralCampaigns: "can-update-doctoral-campaigns",
  canPreviewDoctoralSchoolCampaigns: "can-preview-doctoral-school-campaigns",
  canCreateDoctoralSchoolCampaigns: "can-create-doctoral-school-campaigns",
  canUpdateDoctoralSchoolCampaigns: "can-update-doctoral-school-campaigns",
  canPreviewDoctoralSchoolDoctorants: "can-preview-doctoral-school-doctorants",
  canManageDoctoralSchoolDoctorants: "can-manage-doctoral-school-doctorants",
  canRecordDoctoralSchoolResults: "can-record-doctoral-school-results",
  canManageDoctoralCampaignDocumentTypes: "can-manage-doctoral-campaign-document-types",
  canPreviewDoctoralExamAdmissionCommittees: "can-preview-doctoral-exam-admission-committees",
  canCreateDoctoralExamAdmissionCommittees: "can-create-doctoral-exam-admission-committees",
  canUpdateDoctoralExamAdmissionCommittees: "can-update-doctoral-exam-admission-committees",
  canPreviewDoctoralExamCommittees: "can-preview-doctoral-exam-committees",
  canCreateDoctoralExamCommittees: "can-create-doctoral-exam-committees",
  canUpdateDoctoralExamCommittees: "can-update-doctoral-exam-committees",
  canDeleteDoctoralExamCommittees: "can-delete-doctoral-exam-committees",
  canApproveDoctoralExamCommittees: "can-approve-doctoral-exam-committees",
  canManageDoctoralLanguageExams: "can-manage-doctoral-language-exams",
  canEnterDoctoralExamGrades: "can-enter-doctoral-exam-grades",
  canPreviewDoctorantCandidacies: "can-preview-doctorant-candidacies",
  canManageDoctoralCampaignRankings: "can-manage-doctoral-campaign-rankings",
  canPreviewDoctoralCampaignRankings: "can-preview-doctoral-campaign-rankings",
  canPreviewApprovedDoctoralCandidacies: "can-preview-approved-doctoral-candidacies",
  canEnrollDoctorants: "can-enroll-doctorants",
  canPreviewDoctorants: "can-preview-doctorants",
  canAddDoctorant: "can-add-doctorant",
  canUpdateDoctorants: "can-update-doctorants",
  canManageDoctorantReports: "can-manage-doctorant-reports",
  canDismissDoctorants: "can-dismiss-doctorants",

  // Dormitory
  canPreviewDormitoryRooms: "can-preview-dormitory-rooms",
  canManageDormitoryRooms: "can-manage-dormitory-rooms",
  canPreviewDormitoryBuildings: "can-preview-dormitory-buildings",
  canManageDormitoryBuildings: "can-manage-dormitory-buildings",
  canPreviewDormitoryRoomTypes: "can-preview-dormitory-room-types",
  canManageDormitoryRoomTypes: "can-manage-dormitory-room-types",
  canPreviewDormitoryRoomConditions: "can-preview-dormitory-room-conditions",
  canManageDormitoryRoomConditions: "can-manage-dormitory-room-conditions",
  canPreviewDormitoryAccommodationPrices: "can-preview-dormitory-accommodation-prices",
  canManageDormitoryAccommodationPrices: "can-manage-dormitory-accommodation-prices",
  canPreviewDormitoryStateSubsidies: "can-preview-dormitory-state-subsidies",
  canManageDormitoryStateSubsidies: "can-manage-dormitory-state-subsidies",
  canPreviewDormitoryCampaigns: "can-preview-dormitory-campaigns",
  canManageDormitoryCampaigns: "can-manage-dormitory-campaigns",
  canPreviewDormitoryAccommodations: "can-preview-dormitory-accommodations",
  canManageDormitoryAccommodations: "can-manage-dormitory-accommodations",
  canPreviewDormitoryAccommodationOrders: "can-preview-dormitory-accommodation-orders",
  canManageDormitoryAccommodationOrders: "can-manage-dormitory-accommodation-orders",
  canPreviewDormitoryPayments: "can-preview-dormitory-payments",
  canManageDormitoryPayments: "can-manage-dormitory-payments",

  // NACID
  canPreviewNacidFlows: "can-preview-nacid-flows",
  canManageNacidFlows: "can-manage-nacid-flows",
  canPreviewNacidRequestPayloads: "can-preview-nacid-request-payloads",

  // Scientific publications
  canPreviewScientificPublications: "can-preview-scientific-publications",
  canUpdateScientificPublications: "can-update-scientific-publications",
};

export default permissions;
